module.exports = __webpack_public_path__ + "static/media/543JamesPBrawleyDrNW_2018-06-12_97.21ef50d1.jpg";